import React from "react";
import { useTranslation } from "react-i18next";
import { CustomButton } from "../../../atoms/CustomButton";
import useAuth from "../../../../hooks/useAuth";
import { PlanTier, usePermissions } from "../../../../utils/permissions";

interface SmsCreditWarningProps {
  smsCredit: number | null | undefined;
  onAddCredit: () => void;
}

const SmsCreditWarning: React.FC<SmsCreditWarningProps> = ({
  smsCredit,
  onAddCredit,
}) => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const permissions = usePermissions(user);

  if (
    !permissions.isAtLeastTier(PlanTier.PREMIUM) ||
    permissions.isPromoTrial()
  ) {
    return null;
  }

  if (smsCredit !== undefined && smsCredit !== null && smsCredit >= 500) {
    return null;
  }

  const messageKey =
    smsCredit === undefined || smsCredit === null || smsCredit === 0
      ? "dashboard.smsCredit.noCreditsMessage"
      : "dashboard.smsCredit.lowCreditsMessage";

  return (
    <div className="mt-1 flex flex-col items-start gap-2">
      <p className="text-sm font-medium text-gray-700 font-figtree">
        {t(messageKey, { count: smsCredit || 0 })}
      </p>
      <CustomButton
        variant="primary"
        size="sm"
        onClick={onAddCredit}
        title={t("dashboard.smsCredit.addCreditsButton") as string}
      />
    </div>
  );
};

export default SmsCreditWarning;
